export const base = {
  cta: 'This is a sample Call-To-Action description!',
  product: 'White Label Product',
  welcome: 'Welcome!',
  upsellHeader: 'Book your next shipment',
};
